import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { HighChartDonutChart } from '../../../shared';
import { FIELD_PHYSICIAN_ENGAGEMENT } from './constants';
import { useSelector } from 'react-redux';

function EngagementSegments() {
    const { fieldTriggerEngagementChart, isLoading } = useSelector((state) => state.fieldEngagement);
    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box className="flex-column-center">
                <Box>
                    <Typography className="text-md-medium gray-900 mb-2">
                        Field Physician Engagement
                    </Typography>
                </Box>
            </Box>
            {isLoading ? <Skeleton variant="rectangular" width='100%' height={400}/>: <HighChartDonutChart
                chartOptions={FIELD_PHYSICIAN_ENGAGEMENT}
                seriesData={fieldTriggerEngagementChart}
            />}
        </Box>
    );
}

export default EngagementSegments;
